/* eslint
    no-empty-function: "warn",
    no-undef: "warn"
*/

import { invoke } from '@shared/easyfy.decorators';
import { parseToBoolean } from '@shared/easyfy.utils';
import { initSlideProductList } from '@webModules/splideHelper';
import productRecommendationsService from '../services/meds.productrecommendations.service';

export namespace Meds.Modules {
  @invoke
  export class ProductRecommendations {

    onInit() {
      this.loadRecommendations();
    }

    public loadRecommendations = async (): Promise<PromiseSettledResult<any>[]> => {
      const productRecommendationContainers = document.querySelectorAll(
        '[data-container="products-recommendations"]'
      );

      if (
        productRecommendationContainers == null ||
        productRecommendationContainers.length === 0
      ) {
        return [];
      }

      const getRecommendationPromises = [];

      productRecommendationContainers.forEach(
        async (productRecommendationContainer) => {
          const productIds = productRecommendationContainer.getAttribute(
            'data-recommendations-product-ids'
          );

          const requestData: productRecommendationsService.ProductRecommendationRequest =
          {
            productIds: productIds != null ? productIds.split(',') : null,
            searchProductId: productRecommendationContainer.getAttribute(
              'data-recommendations-search-product-id'
            ),
            brandId: productRecommendationContainer.getAttribute(
              'data-recommendations-brand'
            ),
            seoCategoryName: productRecommendationContainer.getAttribute(
              'data-recommendations-category'
            ),
            isExclusiveToBrand: parseToBoolean(
              productRecommendationContainer.getAttribute(
                'data-recommendations-exclusive'
              )
            ),
            isMedsSelect: parseToBoolean(
              productRecommendationContainer.getAttribute(
                'data-recommendations-medsselect'
              )
            ),
            personalize: parseToBoolean(
              productRecommendationContainer.getAttribute(
                'data-recommendations-personalize'
              )
            ),
            recommendationType: productRecommendationContainer.getAttribute(
              'data-recommendations-type'
            ),
            productPageHasVideo: productRecommendationContainer.getAttribute(
              'data-product-page-has-video'
            ) != null,
            noCache:
              productRecommendationContainer.getAttribute(
                'data-no-outputcache'
              ) != null
          };

          const promise = productRecommendationsService
            .GetProductRecommendations(requestData)
            .then((response) => {
              if (response.status !== 200 || !response.data?.partial) {
                productRecommendationContainer.innerHTML = '';
                return;
              }

              productRecommendationContainer.innerHTML = response.data.partial;
              const productListComponent =
                productRecommendationContainer.querySelector(
                  '[data-container="productlist-scroll"]'
                );

              if (!productListComponent) {
                return;
              }

              initSlideProductList(productListComponent);
            })
            .catch((error) => {
              console.log(error);
              productRecommendationContainer.innerHTML = '';
            });

          getRecommendationPromises.push(promise);
        }
      );

      return Promise.allSettled(getRecommendationPromises);
    };
  }
}

export default Meds.Modules.ProductRecommendations;
